<template>
  <v-container fluid class="pl-5">
    <v-row
        class="pt-5"
    >
      <v-col
          cols="4"
      >
        <v-select
            v-model="selectedType"
            :items="computedTypesList"
            return-object
        />
      </v-col>
    </v-row>
    <v-row
        justify="start"
        align="center"
        class="mt-4"
    >
      <div
          style="width: 150px"
          class="mr-10"
      >
        <v-text-field
            label="Customer"
            v-model="customerName"
        />
      </div>

      <div
          style="width: 200px"
          class="mr-3"
      >
        <v-dialog
            v-model="dialogs.dateTimePicker.isOpened"
            width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="computedDateTime"
                label="Date and time"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-if="getDialogData('dateTimePicker', 'isDatePicker')"
              v-model="selectedDate"
              scrollable
              @input="switchToTimePicker"
          />
          <v-time-picker
              v-if="getDialogData('dateTimePicker', 'isTimePicker')"
              v-model="selectedTime"
              format="24hr"
              full-width
              @click:minute="setZeroTimeSeconds"
          />
        </v-dialog>
      </div>

      <div
          class="mr-10"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
              <v-btn
                  class="ma-2"
                  v-bind="attrs"
                  v-on="on"
                  x-small
                  fab
                  @click="setLastUTCDateTime"
              >
                <v-icon>mdi-backup-restore</v-icon>
              </v-btn>
            </template>
          Set to last UTC date and time
        </v-tooltip>
      </div>

      <div
          class="mr-10"
      >
        <v-btn
            color="info"
            class="ma-2"
            @click="fetchData"
            :disabled="!customerName || !computedDateTime"
        >
          {{ isGetFullLogs ? 'get file' : 'get logs number' }}
        </v-btn>
      </div>

      <div
          class="mr-10"
      >
        <v-switch
            v-model="isGetFullLogs"
            label="Get Full Logs"
            class="ma-2"
        >
          Set Last UTC
        </v-switch>
      </div>
    </v-row>
    <v-alert
        v-if="isGetFullLogs"
        dense
        border="left"
        type="warning"
    >
      Full logs retrieving may take extra cost
    </v-alert>
    <div
        v-if="result.customer_name"
    >
      <div>Customer: <b>{{ result.customer_name }}</b></div>
      <div>Interval (UTC):
        <b>{{ result.utc_date_time_begin }} - {{ result.utc_date_time_end }}</b>
      </div>
      <div>Logs Number: <b>{{ result.logs_number }}</b></div>
    </div>

  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import manageDialogsMixin from '../mixins/manageDialogsMixin';

export default {
  name: 'LogsTracking',

  mixins: [
    manageDialogsMixin,
  ],

  created() {
    this.setLastUTCDateTime();

    this.selectedType = this.computedTypesList[0] ?? null;
  },

  data: () => ({
    customerName: null,
    selectedDate: null,
    selectedTime: null,
    selectedDateTime: null,
    selectedType: null,
    isGetFullLogs: false,

    result: {
      customer_name: null,
      utc_date_time_begin: null,
      utc_date_time_end: null,
      logs_number: null,
    },

    dialogs: {
      dateTimePicker: {
        isOpened: false,
        data: {
          isDatePicker: true,
          isTimePicker: false,
          date: null,
          hour: null,
        },
        defaults: {
          isDatePicker: true,
          isTimePicker: false,
          date: null,
          hour: null,
        },
      },
    },

  }),

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    async fetchData() {
      if (this.isGetFullLogs) {
        await this.$requestHelpers
          .get(
            'api/admin/analytics/getCustomerLogs',
            {
              responseType: 'blob',
              params: {
                customer_name: this.customerName,
                date_time: this.computedDateTime,
                type: this.selectedType.value,
              },
            },
          )
          .then((response) => {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement('a');
            const headerval = response.headers['content-disposition'];
            const filename = headerval.match(/filename=(.*)/);

            fileLink.href = fileURL;
            fileLink.setAttribute('download', filename[1]);
            document.body.appendChild(fileLink);

            fileLink.click();
          }).catch((error) => {
            if (error.response) {
              if (error.response.status === 403) {
                this.$router.push({ name: 'root' });
              }
            }
          });
        return;
      }

      await this.$requestHelpers
        .get(
          'api/admin/analytics/getCustomerLogsNumber',
          {
            params: {
              customer_name: this.customerName,
              date_time: this.computedDateTime,
              type: this.selectedType.value,
            },
          },
        ).then((response) => {
          this.result = response.data.result;
        }).catch((error) => {
          if (error.response) {
            if (error.response.status === 403) {
              this.$router.push({ name: 'root' });
            }
          }
        });
    },

    setLastUTCDateTime() {
      const currentDate = new Date();
      const year = currentDate.getUTCFullYear();
      const month = currentDate.getUTCMonth() + 1;
      const day = currentDate.getUTCDate();
      const hours = currentDate.getUTCHours();
      const minutes = currentDate.getUTCMinutes();

      this.selectedDate = `${String(year).padStart(2, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      this.selectedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:00`;
    },

    switchToTimePicker() {
      this.dialogs.dateTimePicker.data.isDatePicker = false;
      this.dialogs.dateTimePicker.data.isTimePicker = true;
    },

    setZeroTimeSeconds() {
      if (this.selectedTime && this.selectedTime.split(':').length === 2) {
        this.selectedTime += ':00';
      }
      this.closeDialog('dateTimePicker');
    },
  },

  computed: {
    computedDateTime() {
      if (!this.selectedDate || !this.selectedTime) {
        return null;
      }

      return `${this.selectedDate} ${this.selectedTime}`;
    },

    computedTypesList() {
      const typesList = [{
        text: 'Track 30 Minutes Logs',
        value: '30_minutes',
      }];
      if (this.hasAnyAbility(this.$constants.ABILITY.SERVICE_LOGS_TRACKING_1_H)) {
        typesList.push({
          text: 'Track 1 Hour Logs',
          value: '1_hour',
        });
      }

      if (this.hasAnyAbility(this.$constants.ABILITY.SERVICE_LOGS_TRACKING_1_D)) {
        typesList.push({
          text: 'Track 1 Day Logs',
          value: '1_day',
        });
      }

      return typesList;
    },
  },

  watch: {
    isGetFullLogs(newVal) {
      if (newVal) {
        this.$confirm('Full logs retrieving may take extra cost.').then((res) => {
          if (!res) this.isGetFullLogs = false;
        });
      }
    },
  },
};
</script>

<style scoped>
.uri {
  cursor: pointer;
  text-decoration: underline;
  color: blue;
}

.uri:hover {
  text-decoration: none;
}

</style>
